import { createNotImplementedMethod } from "../utils";
var NotImplementedCountriesRepository = /** @class */ (function () {
    function NotImplementedCountriesRepository() {
        this.getCountries = createNotImplementedMethod();
    }
    return NotImplementedCountriesRepository;
}());
export { NotImplementedCountriesRepository };
